import { render } from "./DomainRow.vue?vue&type=template&id=2333cffd"
import script from "./DomainRow.vue?vue&type=script&lang=js"
export * from "./DomainRow.vue?vue&type=script&lang=js"

import "./DomainRow.vue?vue&type=style&index=0&id=2333cffd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__